import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Divider,
  makeStyles,
  Modal,
  Backdrop,
  Fade,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
      outline: 'none',
    },
    root: {
      minWidth: 400,
    },
    actions: {
      justifyContent: 'flex-end',
    },
    deleteButton: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.error.dark,
      },
    },
  })
);

type Props = {
  open: boolean;
  prizeTitle: string;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
};

export const DeletePrizeModal = ({ open, prizeTitle, onConfirm, onClose, loading }: Props) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.form}>
          <Card className={classes.root}>
            <CardHeader title="Удаление приза" />
            <Divider />
            <CardContent>
              <Typography>Вы действительно хотите удалить приз "{prizeTitle}"?</Typography>
            </CardContent>
            <CardActions className={classes.actions}>
              <Button
                className={classes.deleteButton}
                onClick={onConfirm}
                disabled={loading}
                size="medium"
                variant="contained"
              >
                Удалить
              </Button>
              <Button onClick={onClose} disabled={loading} size="medium" variant="contained">
                Отменить
              </Button>
            </CardActions>
          </Card>
        </div>
      </Fade>
    </Modal>
  );
};
